import React, { useState, useEffect } from "react";
import { Plus, Edit, Trash2 } from "lucide-react";

const CadastroCategorias = () => {
  const [nomeCategoria, setNomeCategoria] = useState("");
  const [categorias, setCategorias] = useState([]);
  const [editandoId, setEditandoId] = useState(null);
  const [novoNome, setNovoNome] = useState("");

  // Modal de exclusão
  const [showModal, setShowModal] = useState(false);
  const [categoriaParaExcluir, setCategoriaParaExcluir] = useState(null);

  useEffect(() => {
    fetchCategorias();
  }, []);

  const fetchCategorias = async () => {
    try {
      const idUsuario = localStorage.getItem("idUsuario")

      const res = await fetch(`https://painel.sismoney.com/categorias.php?idUsuario=${idUsuario}`);
      const data = await res.json();
      setCategorias(data);
    } catch (err) {
      console.error("Erro ao buscar categorias:", err);
    }
  };

  const handleCriarCategoria = async (e) => {
    const idUsuario = localStorage.getItem("idUsuario")

    e.preventDefault();
    try {
      const res = await fetch("https://painel.sismoney.com/categorias.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ nome: nomeCategoria, idUsuario: idUsuario }),
      });

      const data = await res.json();
      if (data.success) {
        setNomeCategoria("");
        window.location.reload();
      }
    } catch (err) {
      console.error("Erro ao criar categoria:", err);
    }
  };

  const confirmarExclusao = (id) => {
    setCategoriaParaExcluir(id);
    setShowModal(true);
  };

  const handleExcluir = async () => {
    try {
      await fetch("https://painel.sismoney.com/categorias.php", {
        method: "DELETE",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idCategoria: categoriaParaExcluir }),
      });
      setShowModal(false);
      setCategoriaParaExcluir(null);
      window.location.reload()
    } catch (err) {
      console.error("Erro ao excluir categoria:", err);
    }
  };

  const handleEditar = async (id) => {
    try {
      await fetch("https://painel.sismoney.com/categorias.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ idCategoria: id, nome: novoNome, action: "update" }),
      });
      setEditandoId(null);
      window.location.reload();
    } catch (err) {
      console.error("Erro ao editar categoria:", err);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-xl w-full max-w-2xl p-8 space-y-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 dark:text-white">
          Cadastro de Categorias
        </h2>

        <form onSubmit={handleCriarCategoria} className="flex gap-4">
          <input
            type="text"
            placeholder="Nome da categoria"
            value={nomeCategoria}
            onChange={(e) => setNomeCategoria(e.target.value)}
            required
            className="flex-1 px-4 py-2 border border-gray-300 rounded-lg dark:bg-gray-700 dark:text-white"
          />
          <button
            type="submit"
            className="inline-flex items-center px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
          >
            <Plus className="w-5 h-5 mr-2" />
            Criar
          </button>
        </form>

        <div className="space-y-4">
          {categorias.map((categoria) => (
            <div
              key={categoria.idCategoria}
              className="flex justify-between items-center p-4 border border-gray-300 dark:border-gray-600 rounded-lg bg-gray-50 dark:bg-gray-700"
            >
              {editandoId === categoria.idCategoria ? (
                <input
                  type="text"
                  value={novoNome}
                  onChange={(e) => setNovoNome(e.target.value)}
                  className="flex-1 px-3 py-1 border border-gray-300 rounded dark:bg-gray-600 dark:text-white"
                />
              ) : (
                <span className="text-lg font-medium text-gray-800 dark:text-white">
                  {categoria.nome}
                </span>
              )}

              <div className="flex gap-2">
                {editandoId === categoria.idCategoria ? (
                  <button
                    onClick={() => handleEditar(categoria.idCategoria)}
                    className="text-green-600 hover:text-green-800"
                  >
                    Salvar
                  </button>
                ) : (
                  <button
                    onClick={() => {
                      setEditandoId(categoria.idCategoria);
                      setNovoNome(categoria.nome);
                    }}
                    className="text-blue-600 hover:text-blue-800"
                  >
                    <Edit />
                  </button>
                )}
                <button
                  onClick={() => confirmarExclusao(categoria.idCategoria)}
                  className="text-red-600 hover:text-red-800"
                >
                  <Trash2 />
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
          <div className="bg-white dark:bg-gray-800 p-6 rounded-xl shadow-xl max-w-sm w-full">
            <h3 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
              Confirmar exclusão
            </h3>
            <p className="text-gray-700 dark:text-gray-300 mb-6">
              Tem certeza que deseja excluir esta categoria? Essa ação não poderá ser desfeita.
            </p>
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-600 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-500 text-gray-900 dark:text-white"
              >
                Cancelar
              </button>
              <button
                onClick={handleExcluir}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                Excluir
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CadastroCategorias;